/** Blog article slugs and titles — keep in sync with `marketingSpecial` `blog.posts` / `blogPost.bySlug`. */
export const BLOG_POST_ENTRIES = [
  {
    slug: 'governed-ai-copilots-evaluation-before-scale',
    title: 'Governed AI copilots: evaluation before scale',
  },
  {
    slug: 'strangler-fig-migrations-auditors-accept',
    title: 'Strangler fig migrations that auditors accept',
  },
  {
    slug: 'finops-shared-cloud-accounts',
    title: 'Building a FinOps practice on shared cloud accounts',
  },
  {
    slug: 'soc-2-evidence-without-slowing-developers',
    title: 'SOC 2 evidence without slowing developers',
  },
] as const;

export type BlogPostSlug = (typeof BLOG_POST_ENTRIES)[number]['slug'];

const BLOG_PREFIX = 'blog/';

export function blogPostPath(slug: string): string {
  return `${BLOG_PREFIX}${slug}`;
}

export function isBlogPostPath(path: string): boolean {
  return path.startsWith(BLOG_PREFIX) && path.length > BLOG_PREFIX.length;
}

export function getBlogPostSlug(path: string): string | null {
  if (!isBlogPostPath(path)) return null;
  return path.slice(BLOG_PREFIX.length);
}

export function getBlogPostPaths(): { path: string; title: string }[] {
  return BLOG_POST_ENTRIES.map(({ slug, title }) => ({
    path: blogPostPath(slug),
    title,
  }));
}
